import { Trash2 } from 'lucide-react';
import type { AppointmentOccurrence } from '../../types/api';
import { formatDateDisplay, formatDateTime } from '../../lib/formatters';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  FormSelect,
  Badge,
} from '../ui';

interface AppointmentOccurrencesProps {
  occurrences?: AppointmentOccurrence[];
  onStatusChange: (id: number, status: string) => void;
  onDelete: (occurrence: AppointmentOccurrence) => void;
  isUpdating: boolean;
}

const editableStatus = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
  canceled: 'Cancelado',
  completed: 'Concluído',
} as const;

const appointmentStatus = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
  canceled: 'Cancelado',
  in_progress: 'Em Andamento',
  completed: 'Concluído',
  expired: 'Expirado',
  rescheduled: 'Reagendado',
} as const;

const getStatusVariant = (status: string) => {
  switch (status) {
    case 'completed':
      return 'success';
    case 'confirmed':
    case 'in_progress':
      return 'info';
    case 'pending':
    case 'rescheduled':
      return 'warning';
    case 'canceled':
    case 'expired':
      return 'error';
    default:
      return 'info';
  }
};

function AppointmentOccurrences({
  occurrences = [],
  onStatusChange,
  onDelete,
  isUpdating,
}: AppointmentOccurrencesProps) {
  return (
    <div className="max-h-[60vh] overflow-y-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Data</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="relative w-72">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {occurrences.map(occurrence => (
            <TableRow key={occurrence.id}>
              <TableCell>{formatDateTime(occurrence.occurrence_date)}</TableCell>
              <TableCell>
                <Badge variant={getStatusVariant(occurrence.status)}>
                  {appointmentStatus[occurrence.status as keyof typeof appointmentStatus]}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <div className="flex items-center justify-end space-x-2">
                  <FormSelect
                    value={occurrence.status}
                    onChange={e => onStatusChange(occurrence.id, e.target.value)}
                    className="w-40"
                    disabled={isUpdating}
                  >
                    {Object.entries(editableStatus).map(([value, label]) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </FormSelect>
                  <Button variant="ghost" onClick={() => onDelete(occurrence)} title="Excluir">
                    <Trash2 className="h-4 w-4 text-red-600" />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default AppointmentOccurrences;
